<template>
  <div>
    <div>
      <div class="btn_editor" :class="{'active': isHtmlMode}" @click="toggleMode(true)">HTML</div>
      <div class="btn_editor" :class="{'active': !isHtmlMode}" @click="toggleMode(false)">Editor</div>
      <div v-if="previewRoute" class="btn_editor" style="width: 200px; float: left;" @click="openPreview">미리보기</div>
    </div>
    
    <!-- HTML -->
    <textarea v-if="isHtmlMode" class="text-editor" v-model="content" :placeholder="placeholder"></textarea>
    <!-- Editor -->
    <div v-else class="quill-editor-wrapper">
      <quill-editor class="editor quill-editor" ref="quillEditor" v-model="content" :options="editorOptions"></quill-editor>
    </div>
  </div>
</template>

<script>
import {quillEditor, Quill} from "vue-quill-editor"
import ImageResize from 'quill-image-resize'
// import * as Emoji from "quill-emoji";

// import theme style
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
// import "quill-emoji/dist/quill-emoji.css";

// hr태그 설정
const BlockEmbed = Quill.import('blots/block/embed');

class HRBlot extends BlockEmbed {
  static create() {
    let node = super.create();
    node.setAttribute('contenteditable', false);
    return node;
  }
}
HRBlot.blotName = 'hr';
HRBlot.tagName = 'hr';

// 폰트 사이즈 설정
const Size = Quill.import('attributors/style/size');
Size.whitelist = ['12px', '14px', '16px', '20px', '24px', '32px', '42px'];

// 폰트 설정
const Fonts = Quill.import('attributors/style/font');
Fonts.whitelist = ['Pretendard-Light', 'Pretendard-Regular', 'Pretendard-Medium', 'Pretendard-Bold','NanumSquare_acL', 'NanumSquare_acR', 'NanumSquareB'];

// Quill 모듈 등록
Quill.register('modules/imageResize', ImageResize);
// Quill.register("modules/emoji", Emoji);
Quill.register(HRBlot);
Quill.register(Size, true);
Quill.register(Fonts, true);

export default {
  name: 'QuillEditor',
  components: { quillEditor },
  props: { 
    value: String, 
    placeholder: {type: String, default: '내용을 입력하세요'}, 
    previewRoute: String, 
    previewTitle: String, 
    previewAttaFileSeq: [String, Number] 
  },

  data() {
    return {
      content: this.value,
      isHtmlMode: false,
    }
  },
  computed: {
    editorOptions() {
      return {
        placeholder: this.placeholder + '\n\n\n\n★★ 필독사항 ★★\n\n이미지 등록 시, 툴바의 이미지 등록 기능 사용해야 합니다.\n(이미지 정렬 : 이미지 드래그 후, 툴바의 텍스트 정렬 기능을 적용하면 됩니다.)',
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], // <strong>, <em>, <u>, <s>
              ["blockquote", "code-block", "hr"], // <blockquote>, <pre class="ql-syntax" spellcheck="false">, <hr>
              // ["emoji"], // 이모지
              ["undo", "redo"], // 실행취소/다시실행 버튼
              [{ header: 1 }, { header: 2 }], // <h1>, <h2>
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }], // <sub>, <sup>
              [{ indent: "-1" }, { indent: "+1" }], // class제어
              [{ direction: "rtl" }], //class 제어
              [{ size: Size.whitelist }], //px 단위 폰트 크기
              [{ header: [1, 2, 3, 4, 5, 6] }], // <h1>, <h2>, <h3>, <h4>, <h5>, <h6>
              [{ font: Fonts.whitelist }], // 글꼴
              [{ color: [] }, { background: [] }], //style="color: rgb(230, 0, 0);", style="background-color: rgb(230, 0, 0);"
              [{ align: [] }], // class
              // ["clean"],
              ["link", "image", "video"],
            ],
            handlers: {
              undo: () => {
                this.$refs.quillEditor.quill.history.undo();
              },
              redo: () => {
                this.$refs.quillEditor.quill.history.redo();
              },
              image: () => {
                this.selectLocalImage();
              },
              hr: () => {
                this.insertHR();
              }
            }
          },
          imageResize: {
            displaySize: true,
            modules: ['Resize', 'DisplaySize', 'Toolbar']
          },
          // 'emoji-toolbar': true,
          // 'emoji-textarea': true,
          // 'emoji-shortname': true
        }
      }
    }
  },
  watch: {
    value(newVal) {
      if (newVal !== this.content) {
        this.content = newVal;
      }
    },
    content(newVal) {
      this.$emit('input', newVal);
    }
  },
  methods: {
    toggleMode(htmlMode) {
      this.isHtmlMode = htmlMode;
    },
    
    selectLocalImage() {
      // 파일 선택 다이얼로그 생성
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');
      input.style.display = 'none';
      
      // 파일 선택 다이얼로그 열기
      input.click();
      
      // 파일 선택 시 처리
      input.onchange = () => {
        const file = input.files[0];
        if (file) {
          this.uploadImageToServer(file);
        }
      };
    },
    
    uploadImageToServer(file) {
      const files = [file];
      
      this.$.fileUpload('IMG', files, '/api/main/bbs/adm/news/setNewsImgInfo', {})
        .then(res => {
          const fileSeq = res.data.fileSeq;
          const imageUrl = '/api/main/bbs/newsCenterImage?attaFileSeq=' + fileSeq;
          
          // Quill 에디터 인스턴스 가져오기
          const quill = this.$refs.quillEditor.quill;
          
          // 현재 커서 위치 가져오기
          const range = quill.getSelection() || { index: 0 };
          
          // 이미지 삽입
          quill.insertEmbed(range.index, 'image', imageUrl);
          
          // 커서를 이미지 다음 위치로 이동
          quill.setSelection(range.index + 1);
        })
        .catch(err => {
          console.error('이미지 업로드 실패:', err);
          alert('이미지 업로드에 실패했습니다.');
        });
    },
    
    openPreview() {
      const params = {
        previewTitle: this.previewTitle,
        previewCont: this.content,
        attaFileSeq: this.previewAttaFileSeq,
      };
      
      // sessionStorage에 데이터 저장
      sessionStorage.setItem('newsPreviewData', JSON.stringify(params));

      const routeData = this.$router.resolve({name: this.previewRoute});
      window.open(routeData.href, '_blank');
    },
    
    insertHR() {
      const quill = this.$refs.quillEditor.quill;
      const range = quill.getSelection() || { index: 0 };
      quill.insertEmbed(range.index, 'hr', true);
      quill.setSelection(range.index + 1);
    },

    // 이모지 > HTML 변환
    getContentForSave() {
      if (!this.content) return this.content;

      const converted = this.content.replace(/[\u{1F000}-\u{1F6FF}]|[\u{1F700}-\u{1F77F}]|[\u{1F780}-\u{1F7FF}]|[\u{1F800}-\u{1F8FF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FA6F}]|[\u{1FA70}-\u{1FAFF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]/gu, 
        function(match) {
          const entity = '&#' + match.codePointAt(0) + ';';
          return entity;
        });

      return converted;
    },
  }
}
</script>

<style scoped>
/* 실행취소/다시실행 */
.quill-editor ::v-deep .ql-undo::before {
  content: '↶';
  font-size: 16px;
  font-weight: bold;
}
.quill-editor ::v-deep .ql-redo::before {
  content: '↷';  
  font-size: 16px;
  font-weight: bold;
}

/* hr 태그 */
.quill-editor ::v-deep hr {
  border: none;
  border-top: 2px solid #ccc;
  margin: 16px 0;
  background: none;
}
.quill-editor ::v-deep .ql-hr::before {
  content: '━';
  font-weight: bold;
  font-size: 14px;
}

/* 폰트 사이즈 */
.quill-editor ::v-deep .ql-picker-item[data-value='12px']::before,
.quill-editor ::v-deep .ql-picker-label[data-value='12px']::before {
  content: '12px' !important;
}
.quill-editor ::v-deep .ql-picker-item[data-value='14px']::before,
.quill-editor ::v-deep .ql-picker-label[data-value='14px']::before {
  content: '14px' !important;
}
.quill-editor ::v-deep .ql-picker-item[data-value='16px']::before,
.quill-editor ::v-deep .ql-picker-label[data-value='16px']::before {
  content: '16px' !important;
}
.quill-editor ::v-deep .ql-picker-item[data-value='20px']::before,
.quill-editor ::v-deep .ql-picker-label[data-value='20px']::before {
  content: '20px' !important;
}
.quill-editor ::v-deep .ql-picker-item[data-value='24px']::before,
.quill-editor ::v-deep .ql-picker-label[data-value='24px']::before {
  content: '24px' !important;
}
.quill-editor ::v-deep .ql-picker-item[data-value='32px']::before,
.quill-editor ::v-deep .ql-picker-label[data-value='32px']::before {
  content: '32px' !important;
}
.quill-editor ::v-deep .ql-picker-item[data-value='42px']::before,
.quill-editor ::v-deep .ql-picker-label[data-value='42px']::before {
  content: '42px' !important;
}

/* 폰트 */
.quill-editor ::v-deep .ql-picker-item[data-value='Pretendard-Light']::before,
.quill-editor ::v-deep .ql-picker-label[data-value='Pretendard-Light']::before {
  content: 'Pretendard-Light' !important;
}
.quill-editor ::v-deep .ql-picker-item[data-value='Pretendard-Regular']::before,
.quill-editor ::v-deep .ql-picker-label[data-value='Pretendard-Regular']::before {
  content: 'Pretendard-Regular' !important;
}
.quill-editor ::v-deep .ql-picker-item[data-value='Pretendard-Medium']::before,
.quill-editor ::v-deep .ql-picker-label[data-value='Pretendard-Medium']::before {
  content: 'Pretendard-Medium' !important;
}
.quill-editor ::v-deep .ql-picker-item[data-value='Pretendard-Bold']::before,
.quill-editor ::v-deep .ql-picker-label[data-value='Pretendard-Bold']::before {
  content: 'Pretendard-Bold' !important;
}
.quill-editor ::v-deep .ql-picker-item[data-value='NanumSquare_acL']::before,
.quill-editor ::v-deep .ql-picker-label[data-value='NanumSquare_acL']::before {
  content: 'NanumSquare_acL' !important;
}
.quill-editor ::v-deep .ql-picker-item[data-value='NanumSquare_acR']::before,
.quill-editor ::v-deep .ql-picker-label[data-value='NanumSquare_acR']::before {
  content: 'NanumSquare_acR' !important;
}
.quill-editor ::v-deep .ql-picker-item[data-value='NanumSquareB']::before,
.quill-editor ::v-deep .ql-picker-label[data-value='NanumSquareB']::before {
  content: 'NanumSquareB' !important;
}

/* .quill-editor ::v-deep #emoji-palette {
  top: 0px !important;
  left: 230px !important;
} */

</style>